import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { Card } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Skeleton } from "@/components/ui/skeleton";
import { Lock } from "lucide-react";

export default function AuditLogs() {
  const { canViewPage } = useAuth();
  const canView = canViewPage("audit_logs");
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!canView) { setLoading(false); return; }
    api.get("/audit-logs").then((r) => setLogs(r.data.items || [])).finally(() => setLoading(false));
  }, [canView]);

  if (!canView) {
    return (
      <div className="flex flex-col items-center justify-center py-24 text-center" data-testid="module-forbidden">
        <Lock className="w-8 h-8 text-muted-foreground mb-3" />
        <p className="font-display text-lg font-medium">You don't have permission to view this page</p>
      </div>
    );
  }

  return (
    <div className="space-y-6" data-testid="audit-logs-page">
      <div>
        <p className="text-[11px] uppercase tracking-[0.28em] text-amber-500 font-semibold">Compliance</p>
        <h1 className="font-display text-3xl sm:text-4xl font-semibold tracking-tight mt-1">Audit Logs</h1>
        <p className="text-sm text-muted-foreground mt-1">Immutable record of system activity.</p>
      </div>

      <Card className="rounded-xl border border-border bg-card overflow-hidden">
        {loading ? <div className="p-6"><Skeleton className="h-40" /></div> :
          <Table>
            <TableHeader>
              <TableRow className="bg-muted/40">
                <TableHead>Timestamp</TableHead>
                <TableHead>User</TableHead>
                <TableHead>Action</TableHead>
                <TableHead>IP</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {logs.length === 0 ? <TableRow><TableCell colSpan={4} className="py-8 text-center text-muted-foreground">No logs yet</TableCell></TableRow> :
                logs.map((l) => (
                  <TableRow key={l.id}>
                    <TableCell className="text-xs font-mono">{l.ts}</TableCell>
                    <TableCell>{l.email}</TableCell>
                    <TableCell><span className="text-xs px-2 py-0.5 rounded bg-primary/10 text-primary">{l.action}</span></TableCell>
                    <TableCell className="text-xs text-muted-foreground">{l.ip || "—"}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        }
      </Card>
    </div>
  );
}
